<template>
	<div class="remind_list">
		<div class="remind_list-header">
			<HomePatientBase
				type="gray"
				toggleArchiveType="button"
				actionClass="patient_button_style"
				:avatar="info.avatar"
				:patient-name="info.name"
				:desc="`${ $status.gender[info.gender] } ${ info.age }岁`"
				:status="info.approveStatus"
				:showRight="false"
			/>
			<div class="remind_list-header-button" @click="$router.push(`/takeMedicine/list/${info.id}`)">
				服药记录<van-icon name="arrow" />
			</div>
		</div>
		<van-list v-model="loading" :finished="finished" @load="onLoad">
			<div class="remind_item van-ellipsis" v-for="item in dataList" :key="item.id" @click="goDetail(item)"
				><span>{{item.reminderTime}}</span
				>{{item.reminderContent}}</div
			>
			<div class="empty_button list_button" @click="add">继续添加</div>
		</van-list>

		<van-popup
			:overlay="false"
			round
			:value="!loading&&dataList.length === 0"
			position="bottom"
			class="no_data_style"
		>
			<van-empty>
				<template #image>
					<img src="../../assets/img/empty_4.png" />
				</template>
				<template #description>
					<div class="empty_description">暂无提醒</div>
					<div class="empty_label">请添加您的服药提醒</div>
				</template>
				<template #default>
					<div class="empty_button" @click="add">去添加</div>
				</template>
			</van-empty>
		</van-popup>
	</div>
</template>
<script>
import HomePatientBase from '../main/components/patient-base.vue'
export default {
    name: 'remind-list',
    data () {
        return {
            showNodata: false,
            loading: false,
            finished: true,
            page: 1,
            limit: 999,
            dataList: []
        }
    },
    components: { HomePatientBase },
    computed: {
        info () {
            return this.$store.getters['account/patientInfo'] || {}
        },
    },
    created () {
        this.getDataList()
    },
    methods: {
        onLoad () {
            this.page += 1
            this.getDataList()
        },
        add () {
            this.$router.push({
                path: `/remind/add`
            })
        },
        getDataList () {
            this.loading = true
            this.$api.patient.getRemindList({ patientId: this.info.id, page: this.page, limit: this.limit, treeLevel: 1 }).then(({ code, data }) => {
                this.loading = false
                if (code == 0) {
                    this.dataList = data.list
                }

            })
        },
        goDetail (item) {
            this.$router.push({
                path: `/remind/add/${item.id}`
            })
        }

    }
}
</script>
<style lang="less" scoped>
.remind_list {
	background-color: #f5f6f7;
	&-header {
		padding: 12px 32px 40px 32px;
		position: relative;
		&-button {
			position: absolute;
			bottom: 40px;
			right: 32px;
			height: 88px;
			display: flex;
			align-items: center;
			font-size: 26px;
			font-weight: normal;
			color: @gray-9;
		}
	}
	.remind_item {
		padding: 35px 28px;
		border-left: 12px solid @primary;
		border-radius: 16px;
		background-color: #ffffff;
		margin: 0 32px 28px 32px;
		font-size: 28px;
		color: @gray-9;
		span {
			display: inline-block;
			width: 90px;
			margin-right: 16px;
			font-size: 32px;
			color: #1f2329;
			font-weight: bold;
		}
	}
}
.no_data_style {
	height: calc(100vh - 168px);
}
.empty_description {
	color: #000000;
	font-size: 40px;
	line-height: 48px;
	font-weight: 600;
	margin-top: 60px;
	text-align: center;
}
.empty_label {
	font-size: 28px;
	color: #999999;
	line-height: 34px;
	margin-top: 28px;
	text-align: center;
}
.empty_button {
	height: 88px;
	width: 340px;
	line-height: 88px;
	text-align: center;
	color: #000000;
	font-size: 28px;
	font-weight: 600;
	border-radius: 12px;
	border: 1px solid #e0e0e0;
	background-color: #ffffff;
}
.list_button {
	margin: 80px auto 0 auto;
}
</style>